import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center justify-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-2xl text-gray-200" }, "Aucun embarquement planifié"),
    /*#__PURE__*/_createElementVNode("p", { class: "my-5 text-gray-400" }, " Vous devez avoir au moins un embarquement planifié afin de pouvoir effectuer les opérations dans cette section. ")
  ])
], -1)
const _hoisted_2 = { class: "flex flex-row items-end justify-end w-full space-x-4" }


export default /*#__PURE__*/_defineComponent({
  __name: 'PassengerAlertNoEmbarkationModal',
  props: {
    open: { type: Boolean },
    name: {},
    isLoading: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any) {

	/**
	 * Displayed when the user lands on the Passenger page but no embarkation is
	 * planned for the current station. Offers to jump to the planning page.
	 *
	 * Extracted from NewPassenger.vue to shrink that file — zero business logic,
	 * just a notice + two buttons.
	 */
	
	

return (_ctx: any,_cache: any) => {
  const _component_ButtonTag = _resolveComponent("ButtonTag")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ModalPage = _resolveComponent("ModalPage")!

  return (_ctx.open)
    ? (_openBlock(), _createBlock(_component_ModalPage, {
        key: 0,
        title: 'Alerte - Informations Requises',
        name: _ctx.name,
        styleContent: "w-full",
        styleFooter: "w-full",
        styleModal: '!w-2/6',
        onClose: _cache[1] || (_cache[1] = (e) => _ctx.$emit('close', e))
      }, {
        content: _withCtx(() => [
          _hoisted_1
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_ButtonTag, {
              label: "Ignorer",
              activeIcon: false,
              icon: "/media/icons/add-icon.svg",
              css: "bg-gray-500 border-secondary text-white px-6 py-2 hover:bg-gray-600 w-full active:bg-gray-500 focus:outline-none",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close', _ctx.name)))
            }),
            _createVNode(_component_router_link, {
              to: { name: 'workspace-planning-embarkation' },
              tag: "a"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ButtonTag, {
                  label: "Effectuer une planification ?",
                  activeIcon: false,
                  icon: "/media/icons/add-icon.svg",
                  loader: _ctx.isLoading,
                  "text-loading": 'Création en cours...',
                  css: "bg-[#219152] border-secondary text-white px-6 py-2 hover:bg-[#167841] w-full active:bg-[#219152] focus:outline-none"
                }, null, 8, ["loader"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["name"]))
    : _createCommentVNode("", true)
}
}

})